var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["image-container", { holder: !_vm.imgLoaded }, "read-only"],
      attrs: {
        "data-url": _vm.url,
        "data-thumbnailUrl": _vm.thumbnailUrl,
        "data-attachmentId": _vm.attachmentId,
        "data-description": _vm.description,
        "data-filename": _vm.filename,
        "data-width": _vm.width,
        "data-height": _vm.height,
        "data-unwell": _vm.unwell,
      },
    },
    [
      _c(
        "div",
        { staticClass: "image-inner-container" },
        [
          _c(
            "no-ssr",
            [
              _vm.unwellMaskVisible
                ? _c("unwell-mask", { on: { unlock: _vm.unlockUnwell } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.unwellMaskVisible
            ? _c(
                "span",
                [
                  _vm.imgError
                    ? _c("svg-icon", {
                        staticClass: "visible-img",
                        attrs: { name: "uploadf" },
                        on: {
                          mousedown: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      })
                    : _c("img", {
                        staticClass: "visible-img",
                        attrs: {
                          "data-src": _vm.url,
                          src: _vm.thumbnailUrl,
                          alt: _vm.filename,
                        },
                        on: {
                          mousedown: function ($event) {
                            $event.preventDefault()
                          },
                          load: _vm.onLoad,
                          error: _vm.onError,
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.description,
              expression: "!!description",
            },
          ],
          staticClass: "desc-input",
        },
        [_vm._v(_vm._s(_vm.description))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }